qw-basket-summary {
  display: flex;
  flex-flow: column;
}

qw-basket-summary .qw-basket-summary__rooms {
  display: flex;
  flex-direction: column;
  width: 100%;
}

qw-basket-summary .qw-basket-summary__room {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
}

qw-basket-summary .qw-basket-summary__extra {
  background: var(--qw-hotel-background);
}

qw-basket-summary .qw-basket-summary__room > div {
  width: 16%;
}

qw-basket-summary .qw-basket-summary__room-taxes {
  font-size: var(--qw-hotel-small-font-size);
}

qw-basket-summary .qw-basket-summary__room--wrapper .qw-basket-summary__extras {
  margin-bottom: var(--qw-hotel-gap-sm);
}

qw-basket-summary .qw-basket-summary__room--wrapper .qw-basket-summary__extras .qw-basket-summary__section-title {
  margin-bottom: var(--qw-hotel-gap-sm);
}
